import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CK_EDITOR_CONFIG, CustomModalService } from '@piqet-angular/shared';
import { AutomationDataService } from 'libs/features/src/lib/layout/administrator/email-automation/automation-data.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-email-template-editor',
  templateUrl: './email-template-editor.component.html',
  styleUrls: ['./email-template-editor.component.scss'],
})
export class EmailTemplateEditorComponent {
  headerData = {
    iconClass: 'fa fa-life-ring',
    materialName: 'Automation',
  };
  selectedTemplate: any;
  templateForm!: FormGroup;
  templateId: any;
  activatedRoute: any;
  @Output() saveOrUpdateTemplate = new EventEmitter<{ payload: any; pathName: any }>();
  modalLabel: any;
  templateData: any;
  ckeEditorValue: any;
  editedBody: any;
  tags: string[] = [];
  duplicateTagError = false;
  emailTemplateTypes: any;
  ckEditorConfig = CK_EDITOR_CONFIG;
  isViewMode: boolean = false;
  // public ckEditorConfig = {
  //   allowedContent: true,
  //   removeFormatAttributes: '',
  //   fullPage: true,
  //   enterMode: 2, // ENTER_BR
  //   pasteFromWordRemoveFontStyles: false,
  //   pasteFromWordRemoveStyles: false,
  //   forcePasteAsPlainText: false,
  //   // toolbar: [
  //   //   { name: 'document', items: ['Source', 'Maximize'] }
  //   // ]
  // };
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private automationDataService: AutomationDataService,
    private formBuilder: FormBuilder,
    private swalService: SwalService,
    private modal: CustomModalService,
    private toaster: ToastrService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;

    this.templateForm = this.formBuilder.group({
      templateName: ['', Validators.required],
      subject: ['', Validators.required],
      // type: [1, Validators.required],
      body: [''],
    });

    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.templateId = this.modal?.modalService?.config?.initialState?.['templateId'];

    this.isViewMode = this.activatedRoute === 'view';

    if (this.isViewMode) {
      this.templateForm.disable();
    }
  }

  async ngOnInit(): Promise<void> {
    this.getMasterEmailTemplateById();
  }

  async getMasterEmailTemplateById() {
    await this.automationDataService
      .getMasterEmailTemplateById(this.templateId)
      .subscribe((res: any) => {
        if (res.data) {
          this.templateData = res.data?.template;
          this.emailTemplateTypes = res.data?.emailTemplateType;
          if (this.templateId != 0) {
            this.patchFormValues(this.templateData);
          }
        }
      });
  }

  patchFormValues(data: any): void {
    this.editedBody = data.body;
    this.ckeEditorValue = data.body;
    var triggerType = this.emailTemplateTypes.find((x: any) => x.id == data.type);
    this.templateForm.patchValue({
      templateName: data.templateName,
      subject: data.subject,
      // type: triggerType,
      body: data.body,
    });
    this.tags = data.tag
      ? data.tag
          .split(',')
          .map((tag: string) => tag.trim())
          .filter((tag: string) => tag !== '')
      : [];
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    const data = {
      templateId: this.templateData?.templateId,
      templateName: this.templateForm.value.templateName,
      type: 1, // default type
      subject: this.templateForm.value.subject,
      body: this.templateForm.controls['body'].value.trimStart() || this.editedBody,
      tag: this.tags.join(','),
    };

    this.saveOrUpdateTemplate.emit({ payload: data, pathName: this.activatedRoute });
  }

  changeEve(event: any) {
    // Get editor data
    // const editorInstance = event.editor;
    this.editedBody = event.data;

    // Strip HTML tags and spaces for validation
    const strippedContent = this.editedBody
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, '')
      .trim();

    // Get source data for backend
    // const sourceData = editorInstance.getData();

    // Form validation
    if (!strippedContent) {
      this.templateForm.get('body')?.setErrors({ required: true });
    } else {
      this.templateForm.get('body')?.setErrors(null);
    }
  }

  addTag(event: any) {
    event.preventDefault();
    const tagValue = event.target.value.trim();

    if (!tagValue) return;

    const newTags = tagValue
      .split(',')
      .map((tag: any) => tag.trim())
      .filter((tag: any) => tag);

    let hasDuplicate = false;

    newTags.forEach((tag: any) => {
      if (!this.tags.includes(tag)) {
        this.tags.push(tag);
      } else {
        hasDuplicate = true;
      }
    });

    this.duplicateTagError = hasDuplicate;
    event.target.value = '';
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  removeTag(tag: string) {
    this.tags = this.tags.filter(t => t !== tag);
    this.duplicateTagError = false;
  }
}
